import React, { Component } from "react";
import { Elements, StripeProvider } from "react-stripe-elements";
import CheckoutForm from "./CheckoutForm";
import { Link } from "react-router-dom";

class Payment extends React.Component {
  render() {
    return (
      <div className="content">
        <h1>Payment</h1>
        <button>
          <Link to="/pandora-commerce/basket">Back to the basket</Link>
        </button>
        <StripeProvider apiKey={process.env.REACT_APP_STRIPE_PUBLIC_KEY}>
          <div className="example">
            <Elements>
              <CheckoutForm total={this.props} />
            </Elements>
          </div>
        </StripeProvider>
      </div>
    );
  }
}

export default Payment;
